import React from 'react';
import { FormGroup } from 'reactstrap';
import ContinentCountrySelect from '../../components/ContinentCountrySelect';

const UserModalOriginationSection = ({
  allowed_origination_countries,
  onChange,
  activeLanguage,
  translate
}) => {
  return (
    <FormGroup>
      <span className="modal-help-text mb-2">
        {translate('user_management_origin_countries-warning')}
      </span>
      <ContinentCountrySelect
        selected={allowed_origination_countries}
        onChange={onChange}
        activeLanguage={activeLanguage}
        translate={translate}
        prefix="orig"
      />
    </FormGroup>
  );
};

export default UserModalOriginationSection;
